import gql from 'graphql-tag';

const USER_TABLE_PREFRENCE = gql`
  query Query {
    userPrefrence {
      tableRows
      stages
      deviceType
      firmwareVersion
      tags
      hardwareVersion
      softwareVersion
      OTAFirmwareVersion
      batch
      vendor
      networkProvider
      arambhDevice
      OTACompatible
    }
  }
`;

export default USER_TABLE_PREFRENCE;
